// Action Types for Communication Center
export const GET_ALL_COMMUNICATIONS_REQUEST = 'GET_ALL_COMMUNICATIONS_REQUEST';
export const GET_ALL_COMMUNICATIONS_SUCCESS = 'GET_ALL_COMMUNICATIONS_SUCCESS';
export const GET_ALL_COMMUNICATIONS_FAILURE = 'GET_ALL_COMMUNICATIONS_FAILURE';

export const ENABLE_DISABLE_COMMUNICATIONS_REQUEST = 'ENABLE_DISABLE_COMMUNICATIONS_REQUEST';
export const ENABLE_DISABLE_COMMUNICATIONS_SUCCESS = 'ENABLE_DISABLE_COMMUNICATIONS_SUCCESS';
export const ENABLE_DISABLE_COMMUNICATIONS_FAILURE = 'ENABLE_DISABLE_COMMUNICATIONS_FAILURE';

export const GET_COMMUNICATIONS_DOCUMENT_TYPE_DROPDOWN_REQUEST = 'GET_COMMUNICATIONS_DOCUMENT_TYPE_DROPDOWN_REQUEST';
export const GET_COMMUNICATIONS_DOCUMENT_TYPE_DROPDOWN_SUCCESS = 'GET_COMMUNICATIONS_DOCUMENT_TYPE_DROPDOWN_SUCCESS';
export const GET_COMMUNICATIONS_DOCUMENT_TYPE_DROPDOWN_FAILURE = 'GET_COMMUNICATIONS_DOCUMENT_TYPE_DROPDOWN_FAILURE';
